import { LANGUAGES } from '@crehana/ts-types';

import type { TTalentUser } from './TalentAuth/hooks/useGetUserData/useGetUserData';

export const getLanguageUser = (user?: TTalentUser | null) => {
  const langEmployee = (
    (user?.language as string) ||
    (user?.company?.language as string) ||
    LANGUAGES.ES
  ).toLowerCase() as LANGUAGES;
  return langEmployee;
};
